import { ChevronUp, X } from "lucide-react";
import { createContext, useContext, type ReactNode } from "react";
import { useSchmal } from "./schmal.ts";
import "./blatt.css";

const BlattKontext = createContext<(() => void) | null>(null);

/** Schließen-Knopf für die Titelzeile eines Panels; erscheint nur im offenen Blatt am Handy. */
export function BlattZu() {
  const zu = useContext(BlattKontext);
  if (!zu) return null;
  return (
    <button type="button" className="knopf knopf-still knopf-symbol blatt-zu" aria-label="Eigenschaften schließen" onClick={zu}>
      <X size={16} aria-hidden="true" />
    </button>
  );
}

/** Am Handy ein Blatt von unten; breiter zeigt es den Inhalt unverändert als Spalte. */
export function Blatt({ offen, titel, onOffen, onSchliessen, children }: { offen: boolean; titel: string; onOffen: () => void; onSchliessen: () => void; children: ReactNode }) {
  const schmal = useSchmal();
  if (!schmal) return <>{children}</>;
  return (
    <div className={`blatt${offen ? " blatt-offen" : ""}`}>
      {offen ? (
        <div className="blatt-griff blatt-griff-offen" aria-hidden="true">
          <span className="blatt-strich" />
        </div>
      ) : (
        <div className="blatt-griff">
          <button type="button" className="blatt-titel" aria-expanded={false} onClick={onOffen}>
            <span className="blatt-strich" aria-hidden="true" />
            <span className="blatt-text">{titel}</span>
            <ChevronUp size={16} aria-hidden="true" />
          </button>
        </div>
      )}
      <div className="blatt-inhalt" inert={!offen}>
        <BlattKontext.Provider value={offen ? onSchliessen : null}>{children}</BlattKontext.Provider>
      </div>
    </div>
  );
}
